import CaseManagerTable from "./CaseManagerTable";

export default CaseManagerTable;
